// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4618":"54ee3277986c7c9b","5611":"a9df574facac1c3b","5811":"f7ee9c6ac85f6bc0","9183":"f760305e94ae3319"}[chunkId] + ".css";
};